import axios from "axios"
import {Params, Responses} from './commonTypes'

const instance = axios.create()

export const intent = async (params: Params.Intent) => {
    const {data} = await instance.post<Responses.Intent>('/api/intent', params)
    return data
}

export const settings = async (params: Params.Settings) => {
    const {data} = await instance.post<Responses.Settings>('/api/settings', params)
    return data
}

export const pay = async (params: Params.Pay) => {
    const {data} = await instance.post<Responses.Pay>('/api/pay', params)
    return data
}